import { FormDialog } from "@/common/components/form-dialog/FormDialog";
import { useDutyScheduleCreation } from "@/pages/duty-schedule/hooks/useDutyScheduleCreation";
import { useTranslation } from "@/translations";

import { DutyScheduleFormFields } from "./DutyScheduleFormFields";

const DIALOG_WIDTH = 750;

interface Props {
  onClose: () => void;
}

export function DutyScheduleCreationDialog({ onClose }: Props) {
  const { t } = useTranslation();
  const { formik } = useDutyScheduleCreation(onClose);

  return (
    <FormDialog
      title={t("dutySchedule.create.dialogTitle")}
      onClose={onClose}
      formik={formik}
      submitLabel={t("dutySchedule.create.submit")}
      submitDisabled={!formik.dirty}
      paperSx={{ width: DIALOG_WIDTH }}
    >
      <DutyScheduleFormFields formik={formik} />
    </FormDialog>
  );
}
